// src/pages/Sysop.js
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Container,
  Typography,
  Paper,
  Alert
} from "@mui/material";

export default function Sysop() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);

useEffect(() => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    setError("Not logged in.");
    return;
  }

  fetch("/authapi/admin_users.php", {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        setRows(data.users);
      } else {
        setError(data.error || "Failed to load users.");
      }
    })
    .catch(() => setError("Server error."));
}, []);



  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "username", headerName: "Username", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "email_verified", headerName: "Verified", width: 120 },
    { field: "is_admin", headerName: "Admin", width: 100 },
    { field: "created_at", headerName: "Created At", width: 200 },
  ];

  return (
    <Box sx={{ px: 2 }}>
      <Box sx={{ maxWidth: 800, mx: "auto", pt: 8 }}>
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" align="center" gutterBottom>
              Sysop Panel
            </Typography>

            {error && <Alert severity="error">{error}</Alert>}

            <Box sx={{ height: 400, width: "100%", mt: 2 }}>
              <DataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                disableRowSelectionOnClick
              />
            </Box>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}
